import request from '@/plugins/request';
export default {
  list: function list() {
    return request({
      url: '/enum/getAll',
      method: 'get',
      timeout: 0
    });
  }
};